import type { ReactNode } from "react";

import classes from "./_css/index.module.css";

type Props = {
  children: ReactNode;
};

export function MobileNavbar({ children }: Props) {
  return <nav className={classes.navbar}>{children}</nav>;
}
